import React from "react";

export const PricingToggle = ({ plan, onChange, testid }) => (
  <div
    data-testid={testid}
    className="inline-flex bg-tan p-1 rounded-full text-xs font-bold tracking-wide select-none"
  >
    <button
      data-testid={`${testid}-onetime`}
      onClick={() => onChange("onetime")}
      className={`px-4 py-2 rounded-full transition-colors duration-300 ${
        plan === "onetime" ? "bg-offwhite text-ink shadow-sm" : "text-faded hover:text-ink"
      }`}
    >
      One-time
    </button>
    <button
      data-testid={`${testid}-subscribe`}
      onClick={() => onChange("subscribe")}
      className={`px-4 py-2 rounded-full transition-colors duration-300 flex items-center gap-1.5 ${
        plan === "subscribe" ? "bg-forest text-cream shadow-sm" : "text-faded hover:text-ink"
      }`}
    >
      Subscribe <span className="opacity-80">-15%</span>
    </button>
  </div>
);
